import { FileCheck, ScrollText, Scale, Vote } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "../site/Reveal";
import { SectionHeading } from "../site/SectionHeading";

export const GOVERNANCE_CARDS = [
  { Icon: FileCheck, title: "Membership Standards", text: "Members enter through a private approval process." },
  { Icon: ScrollText, title: "Rules & Bylaws", text: "Established standards govern participation within the MST network." },
  { Icon: Scale, title: "Accountability", text: "Members are accountable to MST community standards." },
  { Icon: Vote, title: "Member Voice", text: "Qualified members can participate in governance and voting according to MST rules." },
];

export const GovernanceSection = () => (
  <section data-testid="governance-section" className="relative bg-[#020A12] py-24 lg:py-32 overflow-hidden">
    <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#006FD6]/10 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-3xl">
        <SectionHeading chapter="04" light label="The MST Difference" title="A Private Network With Real Governance" />
        <Reveal delay={0.15}>
          <p className="mt-7 text-[#B7C0CC] leading-[1.8]">
            MST is not simply a networking group. MST serves as the governing authority behind a
            private member network with defined rules, bylaws, membership standards,
            accountability, leadership, and enforcement.
          </p>
        </Reveal>
      </div>
      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7">
        {GOVERNANCE_CARDS.map(({ Icon, title, text }, i) => (
          <motion.div
            key={title}
            data-testid={`governance-card-${i}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -6 }}
            className="rounded-2xl border border-[#009BFF]/25 bg-gradient-to-b from-[#062541]/90 to-[#041525]/80 p-8 hover:border-[#00C4F4]/50 hover:shadow-[0_0_25px_rgba(0,155,255,0.12)] transition-[border-color,box-shadow] duration-300"
          >
            <span className="text-xs font-bold text-[#8996A6] tracking-widest" style={{ fontFamily: "var(--font-heading)" }}>
              {String(i + 1).padStart(2, "0")}
            </span>
            <div className="mt-5 w-12 h-12 rounded-full bg-[#009BFF]/15 border border-[#00C4F4]/35 flex items-center justify-center">
              <Icon size={22} strokeWidth={1.5} className="text-[#00C4F4]" />
            </div>
            <h3 className="mt-6 text-base font-extrabold text-white" style={{ fontFamily: "var(--font-heading)" }}>{title}</h3>
            <p className="mt-3 text-sm text-[#B7C0CC] leading-relaxed">{text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
